export default __webpack_public_path__ + "static/media/masaref-keshavarzi.c2c3413e.png";